import React, { lazy, Suspense } from 'react';
import './App.scss';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from 'react-router-dom';
import HomePage from './pages/Home';
import Pricing from './pages/Pricing/Pricing';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import Tools from './pages/Tools/Tools';
import Blogs from './pages/Blogs/Blogs';
// import Privacy from './pages/Privacy/Privacy';
import BlogsMobilePreview from './pages/Blogs/partials/BlogsMobilePreview/BlogsMobilePreview';
import DeleteAccount from './pages/DeleteAccount/DeleteAccount';
import DeleteData from './pages/DeleteData/DeleteData';
import ScrollToTop from './components/common/ScrollToTop';

const Privacy = lazy(() => import('./pages/Privacy/Privacy'));


function App() {
  return (
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar />
        
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/tools" element={<Tools />} />
          <Route path="/blog" element={<Blogs />} />
          <Route path="/delete-account" element={<DeleteAccount />} />
          <Route path="/delete-data" element={<DeleteData />} />
          <Route path="/blog/:id" element={<BlogsMobilePreview />} />
          <Route
            path="/privacy-policy"
            element={
              <Suspense fallback={<div>Loading...</div>}>
                <Privacy />
              </Suspense>
            }
          />
        </Routes>
        
        <Footer />
      </div>
    </Router>
  );
}

export default App;
